(ns practitest.frontend.folders
  (:require [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]
            [ajax.core :as ajax]
            [clojure.string :as str]
            [practitest.frontend.components.grid.common :as gc]))


(defn find-folder [folder-id possible-values]
  (first (filter #(= (:id %) folder-id) possible-values)))

;; In-grid folder field
(gc/register-field-type!
 :folder_id
 gc/header-title
 (fn [{:keys [field] :as column-info} row]
    ;; sort by folder_id
   (get row field))
  ;; Folders should be passed here in column-info
 (fn [{:keys [field folders] :as column-info} row]
   (when-let [folder-id (get row field)]
     (if-let [folder (find-folder folder-id folders)]
       (:label folder)
       (str "Unknown Folder " (pr-str folder-id))))))


(defn is-folders-enabled [module]
  (let [entity-fields @(re-frame/subscribe [::subs/all-entity-fields])
        module-fields (get entity-fields (keyword (str/lower-case module)))]
    (contains? module-fields :folder_id)))
;; re-frame wiring

;; Data fetch
(re-frame/reg-event-db
 ::got-folders
 (fn [db [_ data]] 
   (assoc db :folders (:items data))))

(re-frame/reg-event-fx
 ::fetch-folders
 (fn [{db :db} [_ entity_name include-descending?]] 
   {:http-xhrio
    {:method          :get
     :uri             (broutes/get-url "folders#index" {:p_id (subs/get-current-project-id db)})
     :params          {"entity_name" entity_name, "include_descending" include-descending?}
     :response-format (ajax/json-response-format {:keywords? true})
     :on-success      [::got-folders]
     :on-failure      [:practitest.frontend.events/api-error ::fetch-folders {}]}}))

;; Subscriptions
(re-frame/reg-sub
 ::folders
 (fn [db _]
   (:folders db)))
